import LegalScreen from "@/screens/Generic/LegalScreen/LegalScreen"

export { getStaticProps, getStaticPaths } from "@/screens/Generic/LegalScreen/data"

export default LegalScreen
